var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.401 12a9.6 9.6 0 0 1 9.6-9.6c5.299.005 9.594 4.3 9.6 9.6 0 5.302-4.298 9.6-9.6 9.6a9.6 9.6 0 0 1-9.6-9.6zm1.6 0a8 8 0 0 0 8 8A8.007 8.007 0 0 0 20 12a8 8 0 1 0-16 0zm7.2 4.8a.8.8 0 1 1 1.6-.002.8.8 0 0 1-1.6.003zm0-2.4v-.595a3.158 3.158 0 0 1 1.577-2.803 1.6 1.6 0 0 0 .8-1.7 1.619 1.619 0 0 0-1.28-1.276A1.6 1.6 0 0 0 10.401 9.6a.8.8 0 0 1-1.602 0 3.201 3.201 0 0 1 6.01-1.542 3.2 3.2 0 0 1-1.265 4.344c-.48.301-.765.836-.744 1.402v.595a.799.799 0 1 1-1.6 0z",
    fill: "#516888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b7c7149ae46c9aea20e30e1cbb5d60d1.svg";
export { ForwardRef as ReactComponent };